<form [formGroup]="form">
    <table class="widget-settings_wrap">
        <!-- Widget Name -->
        <tr class="field">
            <td>
                <label class="label-text" for="widget_name">
                    {{'components.widgets.common.settings_widget_name' | l10n}}
                </label>
            </td>
            <td>
                <input class="text-input" type="text" id="widget_name" [formControl]="form.controls.title" autofocus />
            </td>
        </tr>

        <!-- Columns Resizing -->
        <tr class="field">
            <td>
                <label class="label-text" #tableColumnsResizingModeLabel>
                    {{'components.table.columns_resizing_label' | l10n}}
                </label>
            </td>
            <td>
                <switch [formControl]="form.controls.columnsResizingMode"
                        [config]="TABLE_COLUMNS_RESIZING_MODE_SWITCH_CONFIG"
                        [labelElement]="tableColumnsResizingModeLabel">
                </switch>
            </td>
        </tr>
    </table>
    <columns-manager
        [columns]="tableColumnsDef"
        [formControl]="form.controls.columns">
    </columns-manager>
</form>
